'use strict';
import React, { PureComponent } from 'react';


class SeccionDetalle extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { detallesModeloElegido, fechaActual, usuarioLogin} = this.props;

        return (
            <div className="AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDetalleSuperior AsientosContables__modalNuevoAsiento__contenedorSeccionDetalle">
                <div className="AsientosContables--overflowHidden AsientosContables--floatLeft AsientosContables__modalNuevoAsiento__contenedorDetalleSuperiorIzquierdo">
                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__titulosDetalleIzquierdo">
                        <div>Indicador de interfaz:</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha">Manual:</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha">Confirmación automática:</div>
                    </div>

                    <div className="AsientosContables--floatLeft">
                        <div className="AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{detallesModeloElegido.length === 0 ? "-" : detallesModeloElegido[0].IndicInterfazDescripcion}</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">Si</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{detallesModeloElegido.length === 0 ? "-" : (detallesModeloElegido[0].ConfirmacionAutomatica ? "Sí" : "No")}</div>
                    </div>
                </div>

                <div className="AsientosContables--overflowHidden AsientosContables--floatLeft AsientosContables--widthAuto">
                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__titulosDetalleIzquierdo">
                        <div>Fecha contabilización:</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha">Estado:</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha">Usuario de alta:</div>
                    </div>

                    <div className="AsientosContables--floatLeft">
                        <div className="AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{fechaActual}</div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">
                            <div className="AsientosContables__SeccionGrillaEstado">
                                Pend. Conf.
                            </div>
                        </div>
                        <div className="seccionRenglonesModelo__renglonModelo__datoAdicionalContenedorDatosDerecha AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{usuarioLogin}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SeccionDetalle;